import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { client, fmtDate, EMAIL_STATES, EMAIL_KINDS } from "@/lib/api";

export function EmailLog({ emails, onChange, emailEnabled, compact }) {
  const [busy, setBusy] = useState("");
  async function retry(id) {
    setBusy(id);
    try { await client.post(`/admin/emails/${id}/retry`); onChange && onChange(); } catch (e) { alert(e.response?.data?.detail || "Yeniden gönderilemedi"); } finally { setBusy(""); }
  }
  return <div className="email-log" data-testid="email-log">
    {!emailEnabled && <div className="notice" data-testid="email-key-notice">Gmail SMTP şifresi (SMTP_PASSWORD) sunucuda tanımlı değil. E-postalar kaydediliyor; şifre tanımlandığında "Yeniden gönder" ile iletilebilir.</div>}
    {emails.length === 0 && <p className="muted" data-testid="email-log-empty">Henüz e-posta kaydı yok.</p>}
    {emails.length > 0 && <table><thead><tr>{!compact && <th>Sipariş</th>}<th>Tür</th><th>Alıcı</th><th>Durum</th><th>Zaman</th><th></th></tr></thead><tbody>
      {emails.map(e => <tr key={e.id} data-testid={`email-row-${e.id}`}>
        {!compact && <td><strong>{e.order_no}</strong></td>}
        <td>{EMAIL_KINDS[e.kind] || e.kind}<small>{e.subject}</small></td>
        <td>{e.to}</td>
        <td><span className={`pill ${e.state}`} data-testid={`email-state-${e.id}`}>{EMAIL_STATES[e.state] || e.state}</span>{e.error && <small title={e.error}>{e.error.slice(0, 60)}</small>}</td>
        <td>{fmtDate(e.sent_at || e.created_at)}</td>
        <td>{e.state !== "sent" && <button className="icon-btn small" disabled={busy === e.id} onClick={() => retry(e.id)} title="Yeniden gönder" data-testid={`email-retry-${e.id}`}><RefreshCw size={13} /></button>}</td>
      </tr>)}
    </tbody></table>}
  </div>;
}
